import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=f8905214&scoped=true"
import script from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=f8905214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8905214",
  null
  
)

export default component.exports